<template>

  <div class="container">
    <div class="survey-title mb40 has-text-centered">What <span
        class="highlight-text">type</span> of cannabis are you looking for?</div>
    <div class="fields-block mb60">
      <h3 class="title has-text-centered">Select as many as you like.</h3>
      <div class="columns justify-content-center">
        <div class="column">
          <div
            class="field is-grouped is-flex-tablet justify-content-center align-items-center is-flex-wrap">
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="type" value="High THC" class="is-checkradio is-block" id="pref-type-hightthc" type="checkbox"
                name="pref-type">
              <label for="pref-type-hightthc"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-highthc.svg" alt="" class="mb10">
                <h4 class="pref-label">High THC</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="type" value="High CBD" class="is-checkradio is-block" id="pref-type-highcbd" type="checkbox"
                name="pref-type">
              <label for="pref-type-highcbd"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-highcbd.svg" alt="" class="mb10">
                <h4 class="pref-label">High CBD</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="type" value="Balanced" class="is-checkradio is-block" id="pref-type-balanced" type="checkbox"
                name="pref-type">
              <label for="pref-type-balanced"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-balanced.svg" alt="" class="mb10">
                <h4 class="pref-label">Balanced</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="type" value="Low THC"  class="is-checkradio is-block" id="pref-type-lowthc" type="checkbox"
                name="pref-type">
              <label for="pref-type-lowthc"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-lowthc.svg" alt="" class="mb10">
                <h4 class="pref-label">Low THC</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="type" value="Low CBD"  class="is-checkradio is-block" id="pref-type-lowcbd" type="checkbox"
                name="pref-type">
              <label for="pref-type-lowcbd"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-lowcbd.svg" alt="" class="mb10">
                <h4 class="pref-label">Low CBD</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="type" value="Not Sure" class="is-checkradio is-block" id="pref-type-notsure" type="checkbox"
                name="pref-type">
              <label for="pref-type-notsure"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-notsure.svg" alt="" class="mb10">
                <h4 class="pref-label">Not Sure</h4>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="steps mt100 mb50">
      <ul class="is-flex justify-content-around">
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class=""></li>
        <li class=""></li>
        <li class=""></li>
        <li class="mr0"></li>
      </ul>
    </div>
    <div class="next-button is-flex align-items-center justify-content-center has-text-centered mb50">
      <a href="#" @click.prevent="back()" class="back-btn is-primary is-hidden-mobile mr40 m0-xs">Back</a>
      <a href="#" @click.prevent="next()" class="button is-primary ml40 is-marginless-tablet">Next</a>
    </div>
    <div
      class="skip-button is-flex-mobile align-items-center justify-content-between has-text-centered mb30">
      <a href="#" @click.prevent="back()" class="back-btn is-primary is-hidden-tablet">Back</a>
      <a href="#" @click.prevent="setStep(4)" class="is-primary">Skip</a>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      type: [],
    };
  },
  computed: {
    ...mapGetters({
      step: "usersurvey/step"
    })
  },
  methods: {
    /**
     * Step back
     */
    back() {
      this.setStep(2);
      this.setSurvey({
        gender: '',
      })
    },

    /**
     * Next step 
     */
    next() {
      if(this.type == '') {
        this.setSnackbar({
          modal: true,
          message: 'Please choose cannabis are you looking for.',
          type: 'warning',
        }) 
      } else {
        this.setSurvey({
          type: this.type
        })
        this.setStep(4);
      }
    },
    ...mapActions({
      setSnackbar: "snackbar/setSnackbar",
      setStep: "usersurvey/setStep",
      setSurvey: "usersurvey/setSurvey"
    })
  },
};
</script>